import { useRpQuery } from '~/composables/graphql'
import { useMutation } from '@tanstack/vue-query'
import type { ChangeContractInput } from '~/resources/graphql/graphql'
import { graphql } from '~/resources/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'
import { useSetCartData } from '~/composables/use-cart'

export function useProgramChangeContractMutation() {
    const query = useRpQuery()
    const activeFacility = useActiveFacility()
    const setCartData = useSetCartData()

    return useMutation({
        mutationFn: async (mutationData: ChangeContractInput) => {
            const response = await query(
                graphql(/** @lang GraphQL */ `
                    mutation ChangeBooking(
                        $input: ChangeContractInput!
                        $facilityId: ID!
                        $capacityResultFilter: CapacityResultFilter!
                    ) {
                        changeContract(input: $input) {
                            __typename
                            ... on ChangeContractResult {
                                recordId
                                record {
                                    __typename
                                    ... on PlanContract {
                                        ...PurchaseProgramContractFragment
                                    }
                                }
                                query {
                                    viewer {
                                        cart(facilityId: $facilityId) {
                                            ...ViewerCartFragment
                                        }
                                    }
                                }
                            }
                            ... on ValidationError {
                                fieldErrors {
                                    message
                                }
                            }
                        }
                    }
                `),
                {
                    input: mutationData,
                    facilityId: activeFacility.value.id,
                    capacityResultFilter: {
                        ignoreContractId: mutationData.id
                    }
                }
            )

            if (response.changeContract.__typename === 'ChangeContractResult') {
                // Update the cart data
                if (response.changeContract.query.viewer !== null) {
                    setCartData(response.changeContract.query.viewer.cart)
                }
                return response.changeContract
            } else {
                throw new Error('Error changing contract')
            }
        }
    })
}
